export default __webpack_public_path__ + "static/media/spidey.7e1c4ccd.png";